import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_REVENUE_MEMBERSHIP_STRIPE_PAYMENT_ELEMENTS_LAYOUT = defineFcm(
	'revenue_membership_stripe_payment_elements_layout',
)
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'Membership Join Page',
		description:
			'Gates the payment layout experiment on the Membership Join Page (depends on revenue_membership_stripe_payment_elements being enabled and on variant)',
		import: false,
		template: {
			enabled: false,
			experimentName: '',
		},
	});
